<template>
  <v-container class="pa-0">
    <v-form ref="form">
      <v-app-bar color="transparent" class="elevation-0 pa-0 page-header-toolbar">
        <page-header-title :title="page_title"></page-header-title>

        <v-spacer></v-spacer>

        <action-button type="back" @click="$router.go(-1)" />
        <action-button type="save" @click="save" />
        <action-button type="delete" @click="del(organisation.id)" v-if="$can('organisation-delete')" />

        <v-btn icon @click="toggleCollapse" class="darken-2">
          <v-icon>{{ collapseExpandIcon }}</v-icon>
        </v-btn>
      </v-app-bar>

      <v-container grid-list-md>
        <v-card>
          <v-card-text class="pa-4">
            <v-layout row wrap>
              <v-flex lg4 md4 sm6 xs12>
                <v-combobox
                  name="organisation.name"
                  v-model="organisation.name"
                  class="required-field"
                  v-validate="'required|max:255'"
                  :label="$t('organisations.name')"
                  :error-messages="errors.collect('organisation.name')"
                  :items="organisations"
                  item-text="text"
                  item-value="vat"
                  :search-input.sync="orgNameSearch"
                  @change="updateOrgVat"
                  autocomplete="new-password"
                  clearable
                  hide-details
                >
                  <template v-slot:append>
                    <span class="d-none">&nbsp;</span>
                  </template>
                  <template v-slot:append-item>
                    <span class="d-none">&nbsp;</span>
                  </template>
                  <template v-slot:no-data>
                    {{ $t("organisations.org_does_not_exist") }}
                  </template>
                  <template v-slot:item="{ index, item }"> {{ item.text }} ({{ item.vat }}) </template>
                </v-combobox>
              </v-flex>
              <v-flex lg2 md4 sm6 xs12>
                <v-text-field
                  name="organisation.vat"
                  ref="vat"
                  v-model="organisation.vat"
                  v-validate="'max:9'"
                  :label="$t('organisations.vat')"
                  :error-messages="errors.collect('organisation.vat')"
                  @keypress="$keyDown_IntOnly($event)"
                  :hint="$t('global.helptext_vat')"
                  persistent-hint
                  :append-outer-icon="'sync'"
                  @click:append-outer="searchOrgByVat(organisation.vat)"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="organisation.email"
                  v-model="organisation.email"
                  v-validate="'email|max:255'"
                  :label="$t('organisations.email')"
                  :error-messages="errors.collect('organisation.email')"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="organisation.code"
                  v-model="organisation.code"
                  v-validate="'max:50'"
                  :label="$t('organisations.code')"
                  :error-messages="errors.collect('organisation.code')"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <vue-tel-input-vuetify
                  :label="$t('organisations.phone')"
                  v-model="organisation.phone"
                  @input="
                    (formattedNumber, { number, valid, country }) => {
                      organisation.phone = number.significant || formattedNumber
                      organisation.phone_code = country.dialCode || null
                    }
                  "
                  placeholder=""
                  name="organisation.phone"
                  :error-messages="errors.collect('organisation.phone')"
                  defaultCountry="NO"
                ></vue-tel-input-vuetify>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-autocomplete
                  name="organisation.selected_customergroups"
                  v-model="selected_customergroups"
                  :items="customergroups"
                  item-text="name"
                  item-value="id"
                  :label="$t('organisations.customergroups')"
                  autocomplete="new-password"
                  :error-messages="errors.collect('organisation.selected_customergroups')"
                  multiple
                  clearable
                >
                  <template v-slot:prepend-item>
                    <v-list-item ripple class="select-all" @click="fn_toggleSelectAllCustomerGroup">
                      <v-list-item-icon>
                        <v-checkbox v-model="toggleSelectAllCustomerGroup" color="primary" readonly></v-checkbox>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title>{{ $t("global.select_all") }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider class="mt-2"></v-divider>
                  </template>
                </v-autocomplete>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-autocomplete
                  name="organisation.selected_members_of"
                  v-model="selected_members_of"
                  :items="members_of"
                  item-text="name"
                  item-value="id"
                  :label="$t('organisations.member_of')"
                  autocomplete="new-password"
                  :error-messages="errors.collect('organisation.selected_members_of')"
                  multiple
                  clearable
                >
                  <template v-slot:prepend-item>
                    <v-list-item ripple class="select-all" @click="fn_toggleSelectAllMemberOf">
                      <v-list-item-icon>
                        <v-checkbox v-model="toggleSelectAllMemberOf" color="primary" readonly></v-checkbox>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title>{{ $t("global.select_all") }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider class="mt-2"></v-divider>
                  </template>
                </v-autocomplete>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12 v-if="false">
                <v-autocomplete
                  name="organisation.certification_company_id"
                  v-model="organisation.certification_company_id"
                  :items="certification_companies"
                  item-text="name"
                  item-value="id"
                  :label="$t('organisations.certification_authority_123service')"
                  autocomplete="new-password"
                  :error-messages="errors.collect('organisation.certification_company_id')"
                  clearable
                ></v-autocomplete>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-checkbox
                  name="organisation.owner"
                  v-model="organisation.owner"
                  :label="$t('organisations.owner')"
                  :error-messages="errors.collect('organisation.owner')"
                ></v-checkbox>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-autocomplete
                  name="organisation.allowed_certification_agencies"
                  v-model="allowed_certification_agencies"
                  :items="certification_agencies"
                  item-text="name"
                  item-value="id"
                  :label="$t('organisations.certification_authority')"
                  autocomplete="new-password"
                  :error-messages="errors.collect('organisation.allowed_certification_agencies')"
                  multiple
                  clearable
                ></v-autocomplete>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12 v-if="organisation.certification_authority">
                <v-text-field
                  name="organisation.certification_id"
                  v-model="organisation.certification_id"
                  v-validate="'max:255'"
                  :label="$t('organisations.certification_id')"
                  :error-messages="errors.collect('organisation.certification_id')"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-checkbox
                  name="organisation.certification_authority"
                  v-model="organisation.certification_authority"
                  :label="$t('organisations.certification_authority')"
                  :error-messages="errors.collect('organisation.certification_authority')"
                ></v-checkbox>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12 v-if="false">
                <v-checkbox
                  name="organisation.certification_authority_123service"
                  v-model="organisation.certification_authority_123service"
                  :label="$t('organisations.certification_authority_123service')"
                  :error-messages="errors.collect('organisation.certification_authority_123service')"
                ></v-checkbox>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-checkbox
                  name="organisation.member_organisation"
                  v-model="organisation.member_organisation"
                  :label="$t('organisations.member_organisation')"
                  :error-messages="errors.collect('organisation.member_organisation')"
                ></v-checkbox>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-dialog ref="dialog" v-model="agreement_active_from_menu" persistent width="290px">
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      name="organisation.agreement_active_from"
                      v-model="computedAgreementActiveFromDate"
                      :label="$t('organisations.agreement_active_from')"
                      :error-messages="errors.collect('organisation.agreement_active_from')"
                      append-icon="event"
                      @click:append="agreement_active_from_menu = true"
                      :hint="'Format: ' + DATE_FORMAT"
                      autocomplete="new-password"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    color="primary"
                    v-model="organisation.agreement_active_from"
                    :locale="this.$locale_bcp47()"
                    first-day-of-week="1"
                  >
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="agreement_active_from_menu = false" class="darken-2">{{ $t("global.ok") }}</v-btn>
                  </v-date-picker>
                </v-dialog>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="organisation.agreement_responsible"
                  v-model="organisation.agreement_responsible"
                  :label="$t('organisations.agreement_responsible')"
                  :error-messages="errors.collect('organisation.agreement_responsible')"
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-dialog ref="dialog" v-model="agreement_cancelled_from_menu" persistent width="290px">
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      name="organisation.agreement_cancelled_from"
                      v-model="computedAgreementCancelledFromDate"
                      :label="$t('organisations.agreement_cancelled_from')"
                      :error-messages="errors.collect('organisation.agreement_cancelled_from')"
                      append-icon="event"
                      @click:append="agreement_cancelled_from_menu = true"
                      :hint="'Format: ' + DATE_FORMAT"
                      autocomplete="new-password"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    color="primary"
                    v-model="organisation.agreement_cancelled_from"
                    :locale="this.$locale_bcp47()"
                    first-day-of-week="1"
                  >
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="agreement_cancelled_from_menu = false" class="darken-2">{{
                      $t("global.ok")
                    }}</v-btn>
                  </v-date-picker>
                </v-dialog>
              </v-flex>
              <v-flex xs12></v-flex>
              <v-flex md2 sm12 xs12 class="pr-4">
                <label class="v-label theme--light">{{ $t("organisations.logo") }}</label>
                <action-button type="upload" text="" @click="openUploadForm()" class="float-right" small />
                <v-img :src="organisation.logo_url ? organisation.logo_url : ''" width="100%" class="mt-4 elevation-2" contain> </v-img>
              </v-flex>
              <v-flex md2 sm12 xs12 class="pr-4">
                <label class="v-label theme--light">{{ $t("organisations.member_logo") }}</label>
                <action-button type="upload" text="" @click="openUploadMemberLogoForm()" class="float-right" small />
                <v-img
                  :src="organisation.member_logo_url ? organisation.member_logo_url : ''"
                  width="100%"
                  class="mt-4 elevation-2"
                  contain
                >
                </v-img>
              </v-flex>
              <v-flex md8 sm12 xs12>
                <v-textarea
                  name="organisation.internal_note"
                  v-model="organisation.internal_note"
                  rows="3"
                  auto-grow
                  :label="$t('organisations.internal_note')"
                  :error-messages="errors.collect('organisation.internal_note')"
                ></v-textarea>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>

        <v-expansion-panels v-model="clpsTenantExp" class="cstm-filter mt-4 elevation-0" v-if="organisation.id">
          <v-expansion-panel>
            <v-expansion-panel-header hide-actions>
              <span>
                <v-icon dark>{{ clpsTenantIcon }}</v-icon>
                {{ $t("tennants.title") }}
              </span>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-layout row wrap>
                <v-flex md12>
                  <v-data-table
                    :headers="tennant_headers"
                    :items="tennants"
                    :items-per-page="tennants.length"
                    :options.sync="tennant_pagination"
                    :footer-props="{
                      showFirstLastPage: true,
                      'items-per-page-options': this.DATATABLE_ITEM_PER_PAGE_OPTIONS,
                      'items-per-page-all-text': $t('global.items_per_page_all_text'),
                      'items-per-page-text': $t('global.items_per_page_text'),
                      'page-text': $t('global.page_text')
                    }"
                    :server-items-length="tennant_total"
                    :loading="tennant_show_loading"
                    :loading-text="$t('global.loading_text')"
                    :no-data-text="$t('global.no_data_text')"
                    :no-results-text="$t('global.no_results_text')"
                    :must-sort="true"
                  >
                    <template v-slot:item.active_from="{ item }">
                      {{ moment.utc(item.active_from).format(DATE_FORMAT) }}
                    </template>

                    <template v-slot:item.status="{ item }">
                      {{ $dd_tennant_status(item.status) }}
                    </template>

                    <template v-slot:item.type="{ item }">
                      {{ $dd_tenant_types(item.type) }}
                    </template>

                    <template v-slot:item.last_migrated_at="{ item }">
                      {{ item.last_migrated_at ? moment(item.last_migrated_at).format(DATE_FORMAT + " " + TIME_FORMAT) : "" }}
                    </template>

                    <template v-slot:item.actions="{ item }">
                      <router-link
                        :to="{
                          path: BACKEND_URL + '/tennants/edit/' + item.id,
                          props: { id: item.id }
                        }"
                        v-if="$can('tennant-edit')"
                      >
                        <action-button type="edit" :icon_only="true" small />
                      </router-link>
                    </template>
                  </v-data-table>
                </v-flex>
              </v-layout>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <v-expansion-panels v-model="clpsInvDetExp" class="cstm-filter mt-4 elevation-0">
          <v-expansion-panel>
            <v-expansion-panel-header hide-actions>
              <span>
                <v-icon dark>{{ clpsInvDetIcon }}</v-icon>
                {{ $t("organisations.invoice_title") }}
              </span>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-layout row wrap>
                <v-flex lg3 md4 sm6 xs12>
                  <v-text-field
                    v-model="organisation.po_number"
                    v-validate="'max:50'"
                    :label="$t('organisations.po_number')"
                    :error-messages="errors.collect('organisation.po_number')"
                    data-vv-name="organisation.po_number"
                    autocomplete="new-password"
                  ></v-text-field>
                </v-flex>
                <v-flex lg3 md4 sm6 xs12>
                  <v-text-field
                    v-model="organisation.invoice_ref"
                    v-validate="'max:50'"
                    :label="$t('organisations.invoice_ref')"
                    :error-messages="errors.collect('organisation.invoice_ref')"
                    data-vv-name="organisation.invoice_ref"
                    autocomplete="new-password"
                  ></v-text-field>
                </v-flex>
                <v-flex lg3 md4 sm6 xs12>
                  <v-text-field
                    v-model="organisation.email_invoice"
                    v-validate="'max:255'"
                    :label="$t('organisations.email_invoice')"
                    :error-messages="errors.collect('organisation.email_invoice')"
                    data-vv-name="organisation.email_invoice"
                    autocomplete="new-password"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <v-expansion-panels v-model="clpsVisAddExp" class="cstm-filter mt-4 elevation-0">
          <v-expansion-panel>
            <v-expansion-panel-header hide-actions>
              <span>
                <v-icon dark>{{ clpsVisAddIcon }}</v-icon>
                {{ $t("organisations.visiting_address_title") }}
              </span>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-layout row wrap>
                <v-flex lg3 md4 sm6 xs12>
                  <v-text-field
                    name="visiting_address.street"
                    v-model="visiting_address.street"
                    v-validate="'max:50'"
                    :label="$t('organisations.visiting_street')"
                    :error-messages="errors.collect('visiting_address.street')"
                    autocomplete="new-password"
                  ></v-text-field>
                </v-flex>
                <v-flex lg1 md4 sm6 xs12>
                  <v-text-field
                    name="visiting_address.zip"
                    v-model="visiting_address.zip"
                    v-validate="'max:10'"
                    :label="$t('organisations.visiting_zip')"
                    :error-messages="errors.collect('visiting_address.zip')"
                    @blur="visitingZipCodeChange"
                    autocomplete="new-password"
                  ></v-text-field>
                </v-flex>
                <v-flex lg2 md4 sm6 xs12>
                  <v-text-field
                    name="visiting_address.city"
                    v-model="visiting_address.city"
                    v-validate="'max:50'"
                    :label="$t('organisations.visiting_city')"
                    :error-messages="errors.collect('visiting_address.city')"
                    autocomplete="new-password"
                  ></v-text-field>
                </v-flex>
                <v-flex lg2 md4 sm6 xs12>
                  <v-text-field
                    name="visiting_addressg.state"
                    v-model="visiting_address.state"
                    v-validate="'max:50'"
                    :label="$t('organisations.visiting_state')"
                    :error-messages="errors.collect('visiting_address.state')"
                    autocomplete="new-password"
                  ></v-text-field>
                </v-flex>
                <v-flex lg3 md4 sm6 xs12>
                  <v-autocomplete
                    name="visiting_address.country"
                    v-model="visiting_address.country"
                    :items="this.$dd_countries()"
                    item-text="text"
                    item-value="key"
                    :label="$t('organisations.visiting_country')"
                    autocomplete="new-password"
                    :error-messages="errors.collect('visiting_address.country')"
                    clearable
                  ></v-autocomplete>
                </v-flex>
              </v-layout>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <v-expansion-panels v-model="clpsInvAddExp" class="cstm-filter mt-4 elevation-0">
          <v-expansion-panel>
            <v-expansion-panel-header hide-actions>
              <span>
                <v-icon dark>{{ clpsInvAddIcon }}</v-icon>
                {{ $t("organisations.invoice_address_title") }}
              </span>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-checkbox v-model="sameAsVisitingAddress" :label="$t('organisations.same_as_visiting')"></v-checkbox>
                </v-flex>
                <v-flex lg3 md4 sm6 xs12>
                  <v-text-field
                    name="invoice_address.street"
                    v-model="invoice_address.street"
                    v-validate="'max:50'"
                    :label="$t('organisations.invoice_street')"
                    :error-messages="errors.collect('invoice_address.street')"
                    autocomplete="new-password"
                  ></v-text-field>
                </v-flex>
                <v-flex lg1 md4 sm6 xs12>
                  <v-text-field
                    name="invoice_address.zip"
                    v-model="invoice_address.zip"
                    v-validate="'max:10'"
                    :label="$t('organisations.invoice_zip')"
                    :error-messages="errors.collect('invoice_address.zip')"
                    @blur="invoiceZipCodeChange"
                    autocomplete="new-password"
                  ></v-text-field>
                </v-flex>
                <v-flex lg2 md4 sm6 xs12>
                  <v-text-field
                    name="invoice_address.city"
                    v-model="invoice_address.city"
                    v-validate="'max:50'"
                    :label="$t('organisations.invoice_city')"
                    :error-messages="errors.collect('invoice_address.city')"
                    autocomplete="new-password"
                  ></v-text-field>
                </v-flex>
                <v-flex lg2 md4 sm6 xs12>
                  <v-text-field
                    name="invoice_address.state"
                    v-model="invoice_address.state"
                    v-validate="'max:50'"
                    :label="$t('organisations.invoice_state')"
                    :error-messages="errors.collect('invoice_address.state')"
                    autocomplete="new-password"
                  ></v-text-field>
                </v-flex>
                <v-flex lg3 md4 sm6 xs12>
                  <v-select
                    name="invoice_address.country"
                    v-model="invoice_address.country"
                    item-text="text"
                    item-value="key"
                    :items="this.$dd_countries()"
                    :label="$t('organisations.invoice_country')"
                    :error-messages="errors.collect('invoice_address.country')"
                    clearable
                  ></v-select>
                </v-flex>
              </v-layout>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <v-expansion-panels v-model="clpsPersonExp" class="cstm-filter mt-4 elevation-0">
          <v-expansion-panel>
            <v-expansion-panel-header hide-actions>
              <span>
                <v-icon dark>{{ clpsPersonIcon }}</v-icon>
                {{ $t("persons.title") }}
              </span>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-layout row wrap>
                <v-flex md12>
                  <v-data-table
                    :headers="person_headers"
                    :items="persons"
                    :items-per-page="persons.length"
                    :options.sync="person_pagination"
                    :footer-props="{
                      showFirstLastPage: true,
                      'items-per-page-options': this.DATATABLE_ITEM_PER_PAGE_OPTIONS,
                      'items-per-page-all-text': $t('global.items_per_page_all_text'),
                      'items-per-page-text': $t('global.items_per_page_text'),
                      'page-text': $t('global.page_text')
                    }"
                    :server-items-length="person_total"
                    :loading="person_show_loading"
                    :loading-text="$t('global.loading_text')"
                    :no-data-text="$t('global.no_data_text')"
                    :no-results-text="$t('global.no_results_text')"
                    :must-sort="true"
                  >
                    <template v-slot:item.organisation_id="{ item }">
                      {{ item.organisation.name }}
                    </template>

                    <template v-slot:item.email="{ item }">
                      {{ item.user.email }}
                    </template>
                  </v-data-table>
                </v-flex>
              </v-layout>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-container>

      <!-- LOGO -->
      <v-dialog v-model="showUploadForm" persistent max-width="960px">
        <div class="form-modal pa-4">
          <v-container class="pa-0">
            <v-form ref="form">
              <v-container grid-list-md>
                <v-card>
                  <v-app-bar flat dense color="secondary">
                    <v-toolbar-title class="subheading">{{ $t("organisations.upload_image") }}</v-toolbar-title>
                  </v-app-bar>

                  <v-card-text class="pa-4">
                    <ValidationObserver ref="org_logo">
                      <v-flex xs12>
                        <ValidationProvider :rules="'sizePerFileInMB:20'" v-slot="{ errors }">
                          <v-file-input
                            v-model="org_logo"
                            accept=".jpg,.jpeg,.png"
                            color="primary"
                            counter
                            :placeholder="$t('organisations.select_image')"
                            prepend-icon="attach_file"
                            outlined
                            :show-size="1000"
                            clearable
                            :error="errors.length > 0"
                            :error-messages="errors[0]"
                          >
                            <template v-slot:selection="{ index, text }">
                              <v-chip color="primary" dark label small>
                                {{ text }}
                              </v-chip>
                            </template>
                          </v-file-input>
                        </ValidationProvider>
                      </v-flex>
                    </ValidationObserver>
                    <v-flex xs12>
                      <v-card
                        @drop.prevent="documentOnDrop($event)"
                        @dragover.prevent="document_dragover = true"
                        @dragenter.prevent="document_dragover = true"
                        @dragleave.prevent="document_dragover = false"
                        :class="{ 'grey lighten-2': document_dragover }"
                      >
                        <v-card-text>
                          <v-row class="d-flex flex-column" dense align="center" justify="center">
                            <v-icon :class="[document_dragover ? 'mt-2, mb-6' : 'mt-5']" size="60">
                              mdi-cloud-upload
                            </v-icon>
                            <p>{{ $t("global.drop_files_here") }}</p>
                          </v-row>
                        </v-card-text>
                      </v-card>
                    </v-flex>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer />

                    <action-button type="cancel" @click="cancelUpload" />
                    <action-button @click="updateImage()" type="upload" :disabled="!org_logo" />
                  </v-card-actions>
                </v-card>
              </v-container>
            </v-form>
          </v-container>
        </div>
      </v-dialog>

      <!-- MEMBER LOGO -->
      <v-dialog v-model="showUploadMLForm" persistent max-width="960px">
        <div class="form-modal pa-4">
          <v-container class="pa-0">
            <v-form ref="form">
              <v-container grid-list-md>
                <v-card>
                  <v-app-bar flat dense color="secondary">
                    <v-toolbar-title class="subheading">{{ $t("organisations.upload_ml_image") }}</v-toolbar-title>
                  </v-app-bar>

                  <v-card-text class="pa-4">
                    <ValidationObserver ref="org_member_logo">
                      <v-flex xs12>
                        <ValidationProvider :rules="'sizePerFileInMB:20'" v-slot="{ errors }">
                          <v-file-input
                            v-model="org_member_logo"
                            accept=".jpg,.jpeg,.png"
                            color="primary"
                            counter
                            :placeholder="$t('organisations.select_image')"
                            prepend-icon="attach_file"
                            outlined
                            :show-size="1000"
                            clearable
                            :error="errors.length > 0"
                            :error-messages="errors[0]"
                          >
                            <template v-slot:selection="{ index, text }">
                              <v-chip color="primary" dark label small>
                                {{ text }}
                              </v-chip>
                            </template>
                          </v-file-input>
                        </ValidationProvider>
                      </v-flex>
                    </ValidationObserver>
                    <v-flex xs12>
                      <v-card
                        @drop.prevent="documentOnDropMember($event)"
                        @dragover.prevent="document_dragover_member = true"
                        @dragenter.prevent="document_dragover_member = true"
                        @dragleave.prevent="document_dragover_member = false"
                        :class="{ 'grey lighten-2': document_dragover_member }"
                      >
                        <v-card-text>
                          <v-row class="d-flex flex-column" dense align="center" justify="center">
                            <v-icon :class="[document_dragover_member ? 'mt-2, mb-6' : 'mt-5']" size="60">
                              mdi-cloud-upload
                            </v-icon>
                            <p>{{ $t("global.drop_files_here") }}</p>
                          </v-row>
                        </v-card-text>
                      </v-card>
                    </v-flex>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer />

                    <action-button type="cancel" @click="cancelUploadMemberLogo" />
                    <action-button @click="updateImageMemberLogo()" type="upload" :disabled="!org_member_logo" />
                  </v-card-actions>
                </v-card>
              </v-container>
            </v-form>
          </v-container>
        </div>
      </v-dialog>
    </v-form>
  </v-container>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate"
import PhoneNumber from "awesome-phonenumber"
import VueTelInputVuetify from "@/mixins/vue-tel-input-vuetify/lib/vue-tel-input-vuetify.vue"

export default {
  name: "OrganisationForm",

  props: ["id", "input_name", "path"],

  components: {
    ValidationObserver,
    ValidationProvider,
    VueTelInputVuetify
  },

  data() {
    return {
      page_title: "",
      predata: {},
      organisation: {
        name: ""
      },
      visiting_address: {},
      invoice_address: {},
      tmp_invoice_address: {},
      sameAsVisitingAddress: false,
      persons: [],
      certification_agencies: [],
      certification_companies: [],

      customergroups: [],
      members_of: [],
      allowed_certification_agencies: [],
      selected_customergroups: [],
      selected_members_of: [],

      showUploadForm: false,
      org_logo: null,

      showUploadMLForm: false,
      org_member_logo: null,

      organisations: [],
      orgNameSearch: null,

      agreement_active_from_menu: false,
      agreement_cancelled_from_menu: false,

      document_dragover: false,
      document_dragover_member: false,

      person_total: 0,
      person_show_loading: false,
      person_refresh: false,
      person_pagination: {
        page: this.$getLocalStorage("__page_OrgPerson_List", "page"),
        itemsPerPage: this.$getSetting("rows_per_page"),
        sortBy: ["first_name"]
      },

      tennants: [],
      tennant_total: 0,
      tennant_show_loading: false,
      tennant_refresh: false,
      tennant_pagination: {
        page: this.$getLocalStorage("__page_OrgTenant_List", "page"),
        itemsPerPage: this.$getSetting("rows_per_page"),
        sortBy: ["subdomain"]
      },

      toggleSelectAllCourseTypeGroup: false,
      toggleSelectAllCourseType: false,
      toggleSelectAllCustomerGroup: false,
      toggleSelectAllMemberOf: false,

      collapseExpand: undefined,
      collapseExpandIcon: "mdi-expand-all-outline",

      clpsTenantIcon: "mdi-expand-all-outline",
      clpsTenantExp: undefined,

      clpsInvDetIcon: "mdi-expand-all-outline",
      clpsInvDetExp: undefined,

      clpsVisAddIcon: "mdi-expand-all-outline",
      clpsVisAddExp: undefined,

      clpsInvAddIcon: "mdi-expand-all-outline",
      clpsInvAddExp: undefined,

      clpsPersonIcon: "mdi-expand-all-outline",
      clpsPersonExp: undefined,

      dictionary: {
        attributes: {
          "organisation.name": this.$t("organisations.name"),
          "organisation.email": this.$t("organisations.email"),
          "organisation.vat": this.$t("organisations.vat"),
          "organisation.code": this.$t("organisations.code"),
          "organisation.phone": this.$t("organisations.phone"),
          "organisation.owner": this.$t("organisations.owner"),
          "organisation.po_number": this.$t("organisations.po_number"),
          "organisation.invoice_ref": this.$t("organisations.invoice_ref"),
          "organisation.email_invoice": this.$t("organisations.email_invoice"),
          "organisation.certification_id": this.$t("organisations.certification_id"),
          "organisation.certification_authority": this.$t("organisations.certification_authority"),
          "organisation.certification_authority_123service": this.$t("organisations.certification_authority_123service"),
          "organisation.allowed_certification_agencies": this.$t("organisations.certification_agencies"),
          "organisation.selected_customergroups": this.$t("organisations.customergroups"),
          "organisation.selected_members_of": this.$t("organisations.member_of"),

          "visiting_address.street": this.$t("organisations.visiting_street"),
          "visiting_address.city": this.$t("organisations.visiting_city"),
          "visiting_address.state": this.$t("organisations.visiting_state"),
          "visiting_address.zip": this.$t("organisations.visiting_zip"),
          "visiting_address.country": this.$t("organisations.visiting_country"),

          "invoice_address.street": this.$t("organisations.invoice_street"),
          "invoice_address.city": this.$t("organisations.invoice_city"),
          "invoice_address.state": this.$t("organisations.invoice_state"),
          "invoice_address.zip": this.$t("organisations.invoice_zip"),
          "invoice_address.country": this.$t("organisations.invoice_country")
        }
      }
    }
  },

  beforeRouteLeave(to, from, next) {
    this.$validator.validateAll().then(() => {
      this.$leaveFormConfirmation(next, this.organisation, this.predata, this.save, this.isFormValid)
    })
  },

  computed: {
    person_headers: {
      get() {
        return [
          { text: this.$t("persons.first_name"), value: "first_name" },
          { text: this.$t("persons.middle_name"), value: "middle_name" },
          { text: this.$t("persons.last_name"), value: "last_name" },
          { text: this.$t("persons.email"), value: "email", sortable: false },
          { text: this.$t("persons.mobile"), value: "mobile", sortable: false }
        ]
      }
    },
    tennant_headers: {
      get() {
        return [
          { text: this.$t("tennants.subdomain"), value: "subdomain" },
          { text: this.$t("tennants.email"), value: "email" },
          { text: this.$t("tennants.status"), value: "status" },
          { text: this.$t("tennants.type"), value: "type" },
          { text: this.$t("tennants.active_from"), value: "active_from" },
          {
            text: this.$t("tennants.payed_for_users"),
            value: "payed_for_users"
          },
          {
            text: this.$t("tennants.last_migrated_at"),
            value: "last_migrated_at"
          },
          {
            text: this.$t("global.actions"),
            value: "actions",
            width: "20%",
            align: "end",
            sortable: false
          }
        ]
      }
    },
    isFormValid() {
      return !Object.keys(this.fields).some((key) => this.fields[key].invalid)
    },
    computedAgreementActiveFromDate: {
      get() {
        return this.organisation.agreement_active_from
          ? this.moment.utc(this.organisation.agreement_active_from).format(this.DATE_FORMAT)
          : ""
      },
      set(val) {
        this.$set(this.organisation, "agreement_active_from", this.$dateFormatChecker(val))
      }
    },
    computedAgreementCancelledFromDate: {
      get() {
        return this.organisation.agreement_cancelled_from
          ? this.moment.utc(this.organisation.agreement_cancelled_from).format(this.DATE_FORMAT)
          : ""
      },
      set(val) {
        this.$set(this.organisation, "agreement_cancelled_from", this.$dateFormatChecker(val))
      }
    }
  },

  watch: {
    sameAsVisitingAddress(val) {
      if (val) {
        this.tmp_invoice_address = this.invoice_address
        this.invoice_address = this.visiting_address
      } else {
        this.invoice_address = this.tmp_invoice_address
      }
    },
    toggleSelectAllCustomerGroup(val) {
      if (val) {
        this.selected_customergroups = this.customergroups.map((a) => a.id)
      } else {
        this.selected_customergroups = []
      }
    },
    toggleSelectAllMemberOf(val) {
      if (val) {
        this.selected_members_of = this.members_of.map((a) => a.id)
      } else {
        this.selected_members_of = []
      }
    },
    person_refresh: {
      handler() {
        if (this.person_refresh && this.organisation.id) {
          this.persons_list()
        }
      }
    },
    person_pagination: {
      handler(newVal, oldVal) {
        if (!_.isEqual(newVal, oldVal)) {
          if (_.has(newVal, "page") && !_.isEqual(newVal.page, oldVal.page)) {
            localStorage.setItem("__page_OrgPerson_List", newVal.page)
          }

          this.person_refresh = true
        }
      }
    },
    tennant_refresh: {
      handler() {
        if (this.tennant_refresh && this.organisation.id) {
          this.tennants_list()
        }
      }
    },
    tennant_pagination: {
      handler(newVal, oldVal) {
        if (!_.isEqual(newVal, oldVal)) {
          if (_.has(newVal, "page") && !_.isEqual(newVal.page, oldVal.page)) {
            localStorage.setItem("__page_OrgTenant_List", newVal.page)
          }

          this.tennant_refresh = true
        }
      }
    },
    orgNameSearch: {
      handler: _.debounce(function(search) {
        if (search) {
          this.searchOrgVatByName(search)
        } else {
          this.organisations = []
        }
      }, 300)
    },
    clpsTenantExp: {
      handler(newVal, oldVal) {
        this.clpsTenantIcon = newVal === undefined ? "mdi-expand-all-outline" : "mdi-collapse-all-outline"
      }
    },
    clpsInvDetExp: {
      handler(newVal, oldVal) {
        this.clpsInvDetIcon = newVal === undefined ? "mdi-expand-all-outline" : "mdi-collapse-all-outline"
      }
    },
    clpsVisAddExp: {
      handler(newVal, oldVal) {
        this.clpsVisAddIcon = newVal === undefined ? "mdi-expand-all-outline" : "mdi-collapse-all-outline"
      }
    },
    clpsInvAddExp: {
      handler(newVal, oldVal) {
        this.clpsInvAddIcon = newVal === undefined ? "mdi-expand-all-outline" : "mdi-collapse-all-outline"
      }
    },
    clpsPersonExp: {
      handler(newVal, oldVal) {
        this.clpsPersonIcon = newVal === undefined ? "mdi-expand-all-outline" : "mdi-collapse-all-outline"
      }
    }
  },

  mounted() {
    this.$validator.localize(this.$getSetting("locale"), this.dictionary)
  },

  created() {
    let lists = [
      {
        key: "customergroups",
        module: "customergroups",
        query: "show_all=true"
      },
      {
        key: "organisations",
        module: "organisations",
        query: "show_all=true&query_member_organisation=1"
      }
    ]

    axios.post(this.API_URL + "request/ddlists", lists).then((res) => {
      this.customergroups = res.data.customergroups

      this.members_of = res.data.organisations
      this.members_of = this.members_of.filter((item) => item.id != this.id)

      axios.get(this.API_URL + "organisations?resourcetype=organisation-basic&query_certification_authority=1").then((res) => {
        this.certification_agencies = res.data.data
        this.certification_agencies = this.certification_agencies.filter((item) => item.id != this.id)
      })

      axios.get(this.API_URL + "organisations?resourcetype=organisation-basic&query_certification_authority_123service=1").then((res) => {
        this.certification_companies = res.data.data
        this.certification_companies = this.certification_companies.filter((item) => item.id != this.id)
      })

      if (!this.id) {
        this.page_title = this.$t("organisations.new_organisation")
        this.organisation = {
          name: ""
        }

        // JSON stringify and parse to remove variable reactiveness
        this.loadPredata()

        this.visiting_address = {
          country: this.$getDefaultDropdown(this.$dd_countries())
        }

        this.invoice_address = {
          country: this.$getDefaultDropdown(this.$dd_countries())
        }
      } else {
        this.title = this.$t("organisations.update_title")

        axios
          .get(this.API_URL + "organisation/" + this.id)
          .then((res) => {
            this.organisation = res.data.data

            // Load organisations dropdown from BRREG
            //this.searchOrgByVat(this.organisation.vat);

            this.visiting_address = res.data.data.addresses.visiting
            this.invoice_address = res.data.data.addresses.invoice
            this.allowed_certification_agencies = this.organisation.allowed_certification_agencies.map((a) => a.id)
            this.selected_customergroups = this.organisation.customer_groups.map((a) => a.id)
            this.selected_members_of = this.organisation.members_of.map((a) => a.id)
            this.page_title = this.$t("organisations.edit_organisation", {
              name: this.organisation.name
            })

            // JSON stringify and parse to remove variable reactiveness
            this.loadPredata()

            this.persons_list()
            this.tennants_list()
          })
          .catch((err) => console.log(err))
      }
    })
  },

  methods: {
    loadPredata() {
      this.predata = JSON.parse(JSON.stringify(this.organisation))
      this.predata.phone_code = "47" // Norway country code

      if (this.predata.phone) {
        let code = PhoneNumber(this.predata.phone).getCountryCode()
        if (code) {
          let mobileJSON = PhoneNumber(this.predata.phone).toJSON()
          this.predata.phone = mobileJSON.number.significant || this.predata.phone
          this.predata.phone_code = code.toString()
        }
      }
    },
    fn_toggleSelectAllCourseTypeGroup() {
      this.toggleSelectAllCourseTypeGroup = !this.toggleSelectAllCourseTypeGroup
    },
    fn_toggleSelectAllCourseType() {
      this.toggleSelectAllCourseType = !this.toggleSelectAllCourseType
    },
    fn_toggleSelectAllCustomerGroup() {
      this.toggleSelectAllCustomerGroup = !this.toggleSelectAllCustomerGroup
    },
    fn_toggleSelectAllMemberOf() {
      this.toggleSelectAllMemberOf = !this.toggleSelectAllMemberOf
    },
    persons_list() {
      this.person_show_loading = true

      let { sortBy, descending, page, itemsPerPage } = this.person_pagination
      let query = this.$queryString(this.person_pagination, {
        organisation_id: this.organisation.id
      })

      axios
        .get(this.API_URL + "persons" + "?" + query)
        .then((res) => {
          this.persons = res.data.data
          this.person_total = res.data.meta.total
          this.person_refresh = false
          this.person_show_loading = false

          this.person_pagination.page = res.data.meta.current_page
          this.person_pagination.itemsPerPage = Number(res.data.meta.per_page)
        })
        .catch((err) => console.log(err))
    },
    tennants_list() {
      this.tennant_show_loading = true

      let { sortBy, descending, page, itemsPerPage } = this.tennant_pagination
      let query = this.$queryString(this.tennant_pagination, {
        organisation_id: this.organisation.id
      })

      axios
        .get(this.API_URL + "tennants" + "?" + query)
        .then((res) => {
          this.tennants = res.data.data
          this.tennant_total = res.data.meta.total
          this.tennant_refresh = false
          this.tennant_show_loading = false

          this.tennant_pagination.page = res.data.meta.current_page
          this.tennant_pagination.itemsPerPage = Number(res.data.meta.per_page)
        })
        .catch((err) => console.log(err))
    },
    save() {
      this.$refs.vat.focus()
      this.$validator.validate()

      this.$validator
        .validateAll()
        .then(() => {
          if (this.isFormValid) {
            let vm = this

            if (!this.organisation.id) {
              // Create
              axios
                .post(this.API_URL + "organisation", {
                  name: this.organisation.name,
                  email: this.organisation.email,
                  vat: this.organisation.vat,
                  code: this.organisation.code,
                  phone: this.$formatPhoneNumber(this.organisation.phone, this.organisation.phone_code),
                  owner: this.organisation.owner,
                  po_number: this.organisation.po_number,
                  invoice_ref: this.organisation.invoice_ref,
                  email_invoice: this.organisation.email_invoice,
                  certification_id: this.organisation.certification_authority ? this.organisation.certification_id : null,
                  certification_authority: this.organisation.certification_authority,
                  certification_authority_123service: this.organisation.certification_authority_123service || null,
                  certification_company_id: this.organisation.certification_company_id || null,
                  member_organisation: this.organisation.member_organisation,
                  allowed_certification_agencies: this.allowed_certification_agencies.join(","),
                  customergroups: this.selected_customergroups.join(","),
                  members_of: this.selected_members_of.join(","),
                  agreement_active_from: this.organisation.agreement_active_from,
                  agreement_cancelled_from: this.organisation.agreement_cancelled_from,
                  agreement_responsible: this.organisation.agreement_responsible,
                  internal_note: this.organisation.internal_note,
                  visiting_address: {
                    street: this.visiting_address.street,
                    city: this.visiting_address.city,
                    state: this.visiting_address.state,
                    zip: this.visiting_address.zip,
                    country: this.visiting_address.country
                  },
                  invoice_address: {
                    street: this.invoice_address.street,
                    city: this.invoice_address.city,
                    state: this.invoice_address.state,
                    zip: this.invoice_address.zip,
                    country: this.invoice_address.country
                  }
                })
                .then((res) => {
                  if (typeof res.data.errors !== "undefined") {
                  } else {
                    if (res.data.data.id) {
                      vm.organisation = res.data.data

                      vm.visiting_address = res.data.data.addresses.visiting
                      vm.invoice_address = res.data.data.addresses.invoice
                      vm.allowed_certification_agencies = vm.organisation.allowed_certification_agencies.map((a) => a.id)
                      vm.page_title = vm.$t("organisations.edit_organisation", {
                        name: vm.organisation.name
                      })

                      vm.uploadImage()
                      vm.uploadImageMemberLogo()

                      vm.persons_list()

                      vm.$awn.success(vm.$t("global.create_success"))
                      vm.$router.replace(this.BACKEND_URL + `/organisations/edit/${vm.organisation.id}`).catch(() => {})

                      vm.updateTenants()
                    }
                  }
                })
                .catch((err) => console.log(err))
            } else {
              // Update
              axios
                .put(this.API_URL + "organisation", {
                  id: this.organisation.id,
                  name: this.organisation.name,
                  email: this.organisation.email,
                  vat: this.organisation.vat,
                  code: this.organisation.code,
                  phone: this.$formatPhoneNumber(this.organisation.phone, this.organisation.phone_code),
                  owner: this.organisation.owner,
                  po_number: this.organisation.po_number,
                  invoice_ref: this.organisation.invoice_ref,
                  email_invoice: this.organisation.email_invoice,
                  certification_id: this.organisation.certification_authority ? this.organisation.certification_id : null,
                  certification_authority: this.organisation.certification_authority,
                  certification_authority_123service: this.organisation.certification_authority_123service || null,
                  certification_company_id: this.organisation.certification_company_id || null,
                  member_organisation: this.organisation.member_organisation,
                  allowed_certification_agencies: this.allowed_certification_agencies.join(","),
                  customergroups: this.selected_customergroups.join(","),
                  members_of: this.selected_members_of.join(","),
                  agreement_active_from: this.organisation.agreement_active_from,
                  agreement_cancelled_from: this.organisation.agreement_cancelled_from,
                  agreement_responsible: this.organisation.agreement_responsible,
                  internal_note: this.organisation.internal_note,
                  visiting_address: {
                    street: this.visiting_address.street,
                    city: this.visiting_address.city,
                    state: this.visiting_address.state,
                    zip: this.visiting_address.zip,
                    country: this.visiting_address.country
                  },
                  invoice_address: {
                    street: this.invoice_address.street,
                    city: this.invoice_address.city,
                    state: this.invoice_address.state,
                    zip: this.invoice_address.zip,
                    country: this.invoice_address.country
                  }
                })
                .then((res) => {
                  vm.organisation = res.data.data

                  vm.visiting_address = res.data.data.addresses.visiting
                  vm.invoice_address = res.data.data.addresses.invoice
                  vm.allowed_certification_agencies = vm.organisation.allowed_certification_agencies.map((a) => a.id)
                  vm.page_title = vm.$t("organisations.edit_organisation", {
                    name: vm.organisation.name
                  })

                  vm.uploadImage()
                  vm.uploadImageMemberLogo()
                  vm.persons_list()

                  vm.$awn.success(vm.$t("global.update_success"))

                  vm.updateTenants()
                })
                .catch((err) => console.log(err))
            }
          } else {
            this.$awn.alert(this.$t("global.form_not_valid"))
          }
        })
        .catch(() => {})
    },
    del(id) {
      let vm = this

      this.$awn.confirm(
        this.$t("global.delete_message"),
        () => {
          return
        },
        () => {
          axios
            .delete(this.API_URL + "organisation/" + id)
            .then((res) => {
              if (res.data.hasOwnProperty("status") && res.data.status == "has-active-tenants") {
                vm.$awn.warning(vm.$t("organisations.has_active_tenants"))
              } else {
                vm.$router.push(this.BACKEND_URL + "/organisations")
                vm.$awn.success(vm.$t("global.delete_success"))
              }
            })
            .catch((err) => console.log(err))
        },
        {
          labels: {
            confirm: "",
            confirmCancel: this.$t("global.yes"),
            confirmOk: this.$t("global.no")
          }
        }
      )
    },
    updateTenants() {
      let vm = this

      this.$awn.confirm(
        this.$t("organisations.update_tenants"),
        () => {
          axios.get(vm.API_URL + "tennants?query_organisation_id=" + vm.organisation.id).then((res) => {
            let tenants = res.data.data

            _.forEach(tenants, function(tenant) {
              axios
                .put(vm.API_URL + "tennants/migration/" + tenant.id)
                .then((res) => {})
                .catch((err) => console.log(err))
            })
          })
        },
        () => {
          return
        },
        {
          labels: {
            confirmOk: vm.$t("global.yes"),
            confirmCancel: vm.$t("global.no")
          }
        }
      )
    },

    // LOGO
    openUploadForm() {
      this.showUploadForm = true
    },

    cancelUpload() {
      this.showUploadForm = false
      this.org_logo = null
    },

    async updateImage() {
      let vm = this

      if (this.$refs.org_logo) {
        const isValid = await this.$refs.org_logo.validate()
        if (!isValid) {
          return
        }
      }

      var tmppath = URL.createObjectURL(this.org_logo)

      if (tmppath) {
        vm.$set(vm.organisation, "logo", "tempImage")
        vm.$set(vm.organisation, "logo_url", tmppath)
        vm.showUploadForm = false
      }
    },

    async documentOnDrop(e) {
      this.document_dragover = false
      let valid_ext = ["jpg", "jpeg", "png"]
      if (e.dataTransfer.files.length) {
        let file = e.dataTransfer.files[0] || null
        if (file) {
          let ext = file.name.split(".").pop()
          if (valid_ext.includes(ext)) {
            this.org_logo = file
          }
        }
      }

      if (this.$refs.org_logo) {
        await this.$refs.org_logo.validate()
      }
    },

    uploadImage() {
      this.loadPredata()
      if (!this.org_logo) return

      let vm = this
      let formData = new FormData()

      formData.append("id", this.organisation.id)
      formData.append("org_logo", this.org_logo)

      axios
        .post(this.API_URL + "organisation/upload", formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then((res) => {
          this.organisation.logo = res.data.data.logo
          this.organisation.logo_url = res.data.data.logo_url

          vm.loadPredata()

          //vm.$awn.success(vm.$t("global.update_success"));
          vm.cancelUpload()
        })
        .catch((err) => console.log(err))
    },

    // MEMBER LOGO
    openUploadMemberLogoForm() {
      this.showUploadMLForm = true
    },

    cancelUploadMemberLogo() {
      this.showUploadMLForm = false
      this.org_member_logo = null
    },

    async updateImageMemberLogo() {
      let vm = this

      if (this.$refs.org_member_logo) {
        const isValid = await this.$refs.org_member_logo.validate()
        if (!isValid) {
          return
        }
      }

      var tmppath = URL.createObjectURL(this.org_member_logo)

      if (tmppath) {
        vm.$set(vm.organisation, "member_logo", "tempImage")
        vm.$set(vm.organisation, "member_logo_url", tmppath)
        vm.showUploadMLForm = false
      }
    },

    async documentOnDropMember(e) {
      this.document_dragover_member = false
      let valid_ext = ["jpg", "jpeg", "png"]
      if (e.dataTransfer.files.length) {
        let file = e.dataTransfer.files[0] || null
        if (file) {
          let ext = file.name.split(".").pop()
          if (valid_ext.includes(ext)) {
            this.org_member_logo = file
          }
        }
      }

      if (this.$refs.org_member_logo) {
        await this.$refs.org_member_logo.validate()
      }
    },

    uploadImageMemberLogo() {
      this.loadPredata()
      if (!this.org_member_logo) return

      let vm = this
      let formData = new FormData()

      formData.append("id", this.organisation.id)
      formData.append("org_member_logo", this.org_member_logo)

      axios
        .post(this.API_URL + "organisation/upload", formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then((res) => {
          this.organisation.member_logo = res.data.data.member_logo
          this.organisation.member_logo_url = res.data.data.member_logo_url

          vm.loadPredata()

          //vm.$awn.success(vm.$t("global.update_success"));
          vm.cancelUploadMemberLogo()
        })
        .catch((err) => console.log(err))
    },

    searchOrgByVat(search) {
      let vm = this

      if (search) {
        this.organisations = []

        axios
          .get(this.BRREG_API_URL + search)
          .then((res) => {
            let data = res.data
            let companyname = this.$formatAPICompanyName(data.navn)
            this.organisations.push({
              key: companyname,
              text: companyname,
              vat: data.organisasjonsnummer
            })
            // Automaticlly set the organisation name
            this.$set(this.organisation, "name", companyname || null)
            this.$set(this.organisation, "vat", data.organisasjonsnummer || null)
          })
          .catch(function(error) {
            vm.$awn.alert(vm.$t("organisations.vat_does_not_exist"))
            vm.$set(vm.organisation, "name", null)
            vm.$set(vm.organisation, "vat", null)
          })

        /*let promise = this.$api1881SearchVAT(search)
        promise
          .then((res) => {
            let data = res.data
            if (data && data.contacts) {
              this.organisations = data.contacts.map((item) => {
                return {
                  id: item.id,
                  key: item.name,
                  text: item.name,
                  vat: item.organizationNumber
                }
              })

              this.$set(this.organisation, "name", this.organisations.length ? this.organisations[0].text : null)
              this.$set(this.organisation, "vat", this.organisations.length ? this.organisations[0].vat : null)
            } else {
              vm.$awn.alert(vm.$t("organisations.vat_does_not_exist"))
            }
          })
          .catch(function(error) {
            vm.$awn.alert(vm.$t("organisations.vat_does_not_exist"))
          })*/
      }
    },
    searchOrgVatByName(search) {
      if (search) {
        this.organisations = []

        let org = this.organisations.find((i) => i.key == search)
        if (org && org.vat) {
        } else {
          axios
            .get(this.BRREG_API_URL + "?navn=" + search)
            .then((res) => {
              let data = res.data
              if (data.page.totalElements > 0) {
                this.organisations = data._embedded.enheter.slice(0, 3).map((item) => {
                  let companyname = this.$formatAPICompanyName(item.navn)
                  return {
                    key: companyname,
                    text: companyname,
                    vat: item.organisasjonsnummer,
                  }
                })
              }
            })
            .catch(function(error) {})
        }

        /*let promise = this.$api1881SearchName(search)
        promise.then((res) => {
          let data = res.data
          if (data && data.contacts) {
            this.organisations = data.contacts.map((item) => {
              return {
                id: item.id,
                key: item.name,
                text: item.name,
                vat: item.organizationNumber
              }
            })
          }
        })*/
      }
    },
    updateOrgVat() {
      if (this.organisation.name && typeof this.organisation.name === "object") {
        let org = this.organisations.find((i) => i.key == this.organisation.name.key)
        if (org) {
          this.$set(this.organisation, "name", org.text || null)
          this.$set(this.organisation, "vat", org.vat || null)
          return
        }

        /*let org = this.organisations.find((i) => i.vat == this.organisation.name.vat)
        if (org) {
          let promise = this.$api1881SearchID(org.id)
          promise
            .then((res) => {
              let data = res.data
              if (data && data.contacts) {
                data = data.contacts[0]

                this.$set(this.visiting_address, "street", data.geography.address.street + " " + data.geography.address.houseNumber)
                this.$set(this.visiting_address, "zip", data.geography.address.postCode)
                this.$set(this.visiting_address, "city", data.geography.address.postArea)
                this.$set(this.visiting_address, "state", data.geography.county)
              }
            })
            .catch(function(error) {
              console.log(error)
            })

          this.$set(this.organisation, "name", org.text)
          this.$set(this.organisation, "vat", org.vat)
          return
        }*/
      }

      this.$set(this.organisation, "name", this.organisation.name || null)
      this.$set(this.organisation, "vat", null)

      this.$set(this.visiting_address, "street", null)
      this.$set(this.visiting_address, "zip", null)
      this.$set(this.visiting_address, "city", null)
      this.$set(this.visiting_address, "state", null)
    },
    visitingZipCodeChange() {
      this.$getCity(this.visiting_address.zip, this.visiting_address.country)
        .then((res) => {
          if (res.status == 200) {
            this.$set(this.visiting_address, "city", res.data.postalCode.city)
          }
        })
        .catch((error) => {
          this.$set(this.visiting_address, "city", null)
        })
    },
    invoiceZipCodeChange() {
      this.$getCity(this.invoice_address.zip, this.invoice_address.country)
        .then((res) => {
          if (res.status == 200) {
            this.$set(this.invoice_address, "city", res.data.postalCode.city)
          }
        })
        .catch((error) => {
          this.$set(this.invoice_address, "city", null)
        })
    },
    toggleCollapse() {
      this.collapseExpand = this.collapseExpand === 0 ? undefined : 0
      this.collapseExpandIcon =
        this.collapseExpand === 1 || this.collapseExpand == undefined ? "mdi-expand-all-outline" : "mdi-collapse-all-outline"

      this.clpsTenantExp = this.collapseExpand
      this.clpsInvDetExp = this.collapseExpand
      this.clpsVisAddExp = this.collapseExpand
      this.clpsInvAddExp = this.collapseExpand
      this.clpsPersonExp = this.collapseExpand
    }
  }
}
</script>

<style scoped>
input[type="file"] {
  position: absolute;
  clip: rect(0, 0, 0, 0);
}
.filezone {
  outline: 2px dashed grey;
  outline-offset: -10px;
  background: #ccc;
  color: dimgray;
  padding: 10px 10px;
  min-height: 80px;
  position: relative;
  cursor: pointer;
}
.filezone:hover {
  background: #c0c0c0;
}

.filezone p {
  font-size: 1.2em;
  text-align: center;
  padding: 10px 50px 10px 50px;
}
div.file-listing img {
  max-width: 90%;
}

div.file-listing {
  margin: auto;
  padding: 10px;
  border-bottom: 1px solid #ddd;
}

div.file-listing img {
  height: 100px;
}
div.success-container {
  text-align: center;
  color: green;
}

div.remove-container {
  text-align: center;
}

div.remove-container a {
  color: red;
  cursor: pointer;
}

a.submit-button {
  display: block;
  margin: auto;
  text-align: center;
  width: 200px;
  padding: 10px;
  text-transform: uppercase;
  background-color: #ccc;
  color: white;
  font-weight: bold;
  margin-top: 20px;
}
</style>
